import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fontawesome/css/all.css';
import './css/main.scss';
import CustomRoute from './CustomRoute';

function App() {
  return (
    <>
      <CustomRoute />
    </>
  );
}

export default App;
